import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-primary text-primary-foreground",
                secondary:
                    "border-transparent bg-secondary text-secondary-foreground",
                destructive:
                    "border-transparent bg-destructive text-destructive-foreground",
                outline: "text-foreground",
                // Interactive variants with hover effects - use when badge is clickable
                interactive:
                    "border-transparent bg-primary text-primary-foreground hover:bg-primary/80 cursor-pointer",
                "interactive-secondary":
                    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 cursor-pointer",
                "interactive-destructive":
                    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80 cursor-pointer",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {
    children?: React.ReactNode;
    className?: string;
    title?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    style?: React.CSSProperties;
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
    ({ className, variant, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(badgeVariants({ variant }), className)}
                {...props}
            />
        );
    },
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
